import {
  IconButton,
  Text,
  Popover,
  Stack,
  RadioGroup,
  Icon,
  StackSeparator,
  Box,
  Button,
  Link as ChakraLink,
} from "@chakra-ui/react";
import { observer } from "mobx-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { IoMdSettings } from "react-icons/io";
import { appRoutes } from "../../../../App";
import { signOut } from "aws-amplify/auth";
import { Link } from "react-router-dom";
import { useStores } from "../../stores/RootStore";
import Avatar from "../CustomAvatar";
import { HamburgerIcon, LockIcon } from "../icons";
import { CustomPopover } from "../CustomPopover";

interface Props {
  email?: string;
}
const SessionMenuBase: React.FC<Props> = ({ email }) => {
  const { accountStore, authStore } = useStores();
  let navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut().then(() => {
      navigate("/");
      window.location.reload();
    });
  };

  return (
    <>
      <CustomPopover
        trigger={
          <IconButton variant="ghost">
            <Avatar size="sm" name={email} />
          </IconButton>
        }
      >
        <Popover.Body p={0}>
          <Stack separator={<StackSeparator />} gap={0}>
            <Box p={3}>
              <Text fontSize="xs" fontWeight="semibold">
                {t("shared:header.signedInAs")}
              </Text>
              {email}
            </Box>
            {!!accountStore.userAccounts.length && (
              <Stack p={3}>
                <Text fontSize="xs" fontWeight="semibold">
                  {t("shared:header.selectedAccount")}
                </Text>

                <RadioGroup.Root
                  colorPalette="primary"
                  value={accountStore.selectedUserAccount?.id}
                  onValueChange={({ value }) => {
                    if (value) {
                      accountStore.setSelectedUserAccount(value);
                    }
                  }}
                >
                  <Stack gap={3} pb={1}>
                    {accountStore.userAccounts.map((ua, i) => (
                      <RadioGroup.Item
                        key={i}
                        value={ua.id}
                        flexGrow={1}
                        cursor={"pointer"}
                      >
                        <RadioGroup.ItemHiddenInput />
                        <RadioGroup.ItemIndicator />
                        <RadioGroup.ItemText flexGrow={1}>
                          {ua.name}
                        </RadioGroup.ItemText>

                        <IconButton
                          asChild
                          size="xs"
                          colorPalette="primary"
                          variant={"ghost"}
                          my={-1}
                        >
                          <Link to={appRoutes.account(ua.accountId)}>
                            <Icon as={IoMdSettings} fontSize="lg" />
                          </Link>
                        </IconButton>
                      </RadioGroup.Item>
                    ))}
                  </Stack>
                </RadioGroup.Root>
              </Stack>
            )}
            {authStore.isSuperAdmin && (
              <ChakraLink asChild>
                <Link to={appRoutes.adminSurveys()}>
                  <Button
                    borderRadius="0px"
                    justifyContent="left"
                    width="100%"
                    variant="ghost"
                  >
                    <HamburgerIcon />
                    Admin backoffice
                  </Button>
                </Link>
              </ChakraLink>
            )}
            <Button
              borderRadius="0px"
              justifyContent="left"
              width="100%"
              variant="ghost"
              onClick={() => {
                handleSignOut();
              }}
            >
              <LockIcon /> <Text>{t("shared:header.logout")}</Text>
            </Button>
          </Stack>
        </Popover.Body>
      </CustomPopover>
    </>
  );
};

export const SessionMenu = observer(SessionMenuBase);
